var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "b-container",
        { attrs: { fluid: "" } },
        [
          _c(
            "b-row",
            [
              _c(
                "b-col",
                { staticClass: "my-1", attrs: { md: "6" } },
                [
                  _c(
                    "b-form-group",
                    { attrs: { horizontal: "", label: "Выберите бренд" } },
                    [
                      _c(
                        "b-form-select",
                        {
                          staticClass: "mr-1",
                          attrs: { options: _vm.selectBrands },
                          model: {
                            value: _vm.selectedBranch,
                            callback: function($$v) {
                              _vm.selectedBranch = $$v
                            },
                            expression: "selectedBranch"
                          }
                        },
                        [
                          _c(
                            "option",
                            {
                              attrs: { slot: "first" },
                              domProps: { value: null },
                              slot: "first"
                            },
                            [_vm._v("-- Не выбрана --")]
                          )
                        ]
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-col",
                { staticClass: "my-1", attrs: { md: "6" } },
                [
                  _c(
                    "b-form-group",
                    { attrs: { horizontal: "", label: "Поиск клиента:" } },
                    [
                      _c(
                        "b-input-group",
                        { staticClass: "d-flex" },
                        [
                          _c("the-mask", {
                            staticClass: "flex-grow-1 pl-2 pr-2",
                            attrs: {
                              masked: true,
                              mask: "8 (###) ###-##-##",
                              placeholder: "8 (###) ##-##-##"
                            },
                            model: {
                              value: _vm.filter,
                              callback: function($$v) {
                                _vm.filter = $$v
                              },
                              expression: "filter"
                            }
                          }),
                          _vm._v(" "),
                          _c(
                            "b-input-group-append",
                            [
                              _c(
                                "b-btn",
                                {
                                  attrs: { disabled: !_vm.filter },
                                  on: {
                                    click: function($event) {
                                      _vm.filter = ""
                                    }
                                  }
                                },
                                [_vm._v("Очистить")]
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "b-row",
            [
              _c("b-table", {
                attrs: {
                  hover: "",
                  "show-empty": "",
                  "empty-text": _vm.emptyText,
                  fields: _vm.fields,
                  items: _vm.ordersByTel
                },
                scopedSlots: _vm._u([
                  {
                    key: "time",
                    fn: function(data) {
                      return [
                        _vm._v(
                          "\n                        " +
                            _vm._s(_vm._f("date")(data.item.time))
                        ),
                        _c("br"),
                        _c("b", [
                          _vm._v(_vm._s(_vm._f("time")(data.item.time)))
                        ]),
                        _c("br"),
                        _vm._v(" "),
                        _c("b", [_vm._v("На день:")]),
                        _vm._v(
                          " " +
                            _vm._s(_vm._f("date")(data.item.forDay)) +
                            "\n                    "
                        )
                      ]
                    }
                  },
                  {
                    key: "productsName",
                    fn: function(data) {
                      return _vm._l(data.item.prods.nodes, function(product) {
                        return _c(
                          "div",
                          { key: product.id, staticClass: "itemGrid" },
                          [
                            _c("span", [_vm._v(_vm._s(product.name))]),
                            _c("span", { staticClass: "prodDet" }, [
                              _c("span"),
                              _c("span", { staticClass: "prodCount" }, [
                                _vm._v(_vm._s(product.count))
                              ]),
                              _c("span", [_vm._v("x")]),
                              _c("span", { staticClass: "prodCost" }, [
                                _vm._v(
                                  _vm._s(
                                    product.cost > 0
                                      ? product.cost + "₽"
                                      : product.pricePoints + "Б."
                                  )
                                )
                              ])
                            ])
                          ]
                        )
                      })
                    }
                  },
                  {
                    key: "productsSumCost",
                    fn: function(data) {
                      return [
                        _vm._v(
                          "\n                            " +
                            _vm._s(_vm.calcSumOrder(data.item.prods.nodes)) +
                            " ₽"
                        ),
                        _c("br")
                      ]
                    }
                  },
                  {
                    key: "orderCost",
                    fn: function(data) {
                      return [
                        _vm._v(
                          "\n                        " +
                            _vm._s(data.item.price) +
                            " ₽"
                        ),
                        _c("br"),
                        _vm._v(
                          "\n                        " +
                            _vm._s(
                              data.item.pricePoints > 0
                                ? data.item.pricePoints + " Б."
                                : ""
                            ) +
                            "\n                    "
                        )
                      ]
                    }
                  },
                  {
                    key: "delivery",
                    fn: function(data) {
                      return [
                        _vm._v(
                          "\n                        " +
                            _vm._s(
                              data.item.typeDelivery.keyword ===
                                _vm.constDelivery.DELIVERY
                                ? _vm.fullAddress(data.item)
                                : data.item.typeDelivery.name
                            ) +
                            "\n                    "
                        )
                      ]
                    }
                  },
                  {
                    key: "client",
                    fn: function(data) {
                      return [
                        data.item.client
                          ? [
                              _vm._v(
                                "\n                            " +
                                  _vm._s(
                                    data.item.client.name
                                      ? data.item.client.name
                                      : "Не указано"
                                  )
                              ),
                              _c("br"),
                              _vm._v(
                                _vm._s(data.item.client.phone) +
                                  "\n                        "
                              )
                            ]
                          : _vm._e(),
                        _vm._v(" "),
                        !data.item.client
                          ? [
                              _vm._v(
                                "\n                            " +
                                  _vm._s(
                                    data.item.fio ? data.item.fio : "Не указано"
                                  ) +
                                  " (не авториз.)"
                              ),
                              _c("br"),
                              _vm._v(
                                _vm._s(data.item.phone) +
                                  "\n                        "
                              )
                            ]
                          : _vm._e()
                      ]
                    }
                  },
                  {
                    key: "typePayment",
                    fn: function(typePayment) {
                      return [
                        _vm._v(
                          "\n                        " +
                            _vm._s(typePayment.value.name) +
                            "\n                    "
                        )
                      ]
                    }
                  },
                  {
                    key: "branch",
                    fn: function(data) {
                      return [
                        _vm._v(
                          "\n                        " +
                            _vm._s(
                              data.item.point
                                ? data.item.point.address
                                : "Не выбрана"
                            ) +
                            "\n                    "
                        )
                      ]
                    }
                  },
                  {
                    key: "status",
                    fn: function(status) {
                      return [
                        _vm._v(
                          "\n                        " +
                            _vm._s(status.value.name) +
                            "\n                    "
                        )
                      ]
                    }
                  },
                  {
                    key: "edit",
                    fn: function(data) {
                      return [
                        data.item.status.keyword !== _vm.constStatus.NEW
                          ? _c(
                              "b-button",
                              {
                                attrs: { size: "md", variant: "info" },
                                on: {
                                  click: function($event) {
                                    return _vm.$emit("repeat-order", data.item)
                                  }
                                }
                              },
                              [_vm._v("Повторить заказ")]
                            )
                          : _vm._e()
                      ]
                    }
                  }
                ])
              })
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-63db61d3", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-63db61d3","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ListOrders.vue
// module id = null
// module chunks = 